import { Constant } from "../../../../constants/constant";
import { useTranslation } from "react-i18next";
import { VariablesConstant } from "../../../../constants/variables";
import { useEffect, useState } from "react";
import { ComStdService } from "../../../../services/common/ComStdService";
import cronstrue from "cronstrue/i18n";
import { useAppSelector } from "../../../../store/hook";

interface ComMap {
  commCd: string;
  commNm: string;
  commNmEn: string;
}
export default function ConnectionDetail({ model, dataMap }: any) {
  const { t, i18n } = useTranslation();
  const lang = useAppSelector((state: any) => state.language.lang);

  const [uaSecModesTcp, setUaSecModesTcp] = useState<any>();
  const [uaSecModesHttps, setUaSecModesHttps] = useState<any>();
  const [uaSecPolicies, setUaSecPolicies] = useState<any>();

  useEffect(() => {
    getUaSecModesHttpsLst();
    getUaSecModesTcpLst();
    getUaSecPoliciesLst();
  }, []);

  const getUaSecModesTcpLst = () => {
    let req = { upCommCd: Constant.SECURITY_MODES_TCP };
    ComStdService.getInstance()
      .getListTccoStd(req)
      .then((res: any) => {
        setUaSecModesTcp(res.data.responseData);
      })
      .catch((err: any) => {});
  };

  const getUaSecModesHttpsLst = () => {
    let req = { upCommCd: Constant.SECURITY_MODES_HTTPS };
    ComStdService.getInstance()
      .getListTccoStd(req)
      .then((res: any) => {
        setUaSecModesHttps(res.data.responseData);
      })
      .catch((err: any) => {});
  };

  const getUaSecPoliciesLst = () => {
    let req = { upCommCd: Constant.SECURITY_POLICIES };
    ComStdService.getInstance()
      .getListTccoStd(req)
      .then((res: any) => {
        setUaSecPolicies(res.data.responseData);
      })
      .catch((err: any) => {});
  };

  return (
    <>
      <div className="form-container">
        <div className="row align-items-center">
          <div className="col-lg-2 form-label-grid">
            <label htmlFor="validationInput" className="form-label">
              {t("dcs0101.form.label.connectionNm")}
            </label>
          </div>
          <div className="col-lg-4">{model.connNm}</div>

          {model.connProtTp && (
            <>
              <div className="col-lg-2 form-label-grid border-left">
                <label htmlFor="validationInput" className="form-label">
                  {t("dcs0101.form.label.connectionProt")}
                </label>
              </div>
              <div className="col-lg-4">{model.protocol.protNm} - {model.connProtTp.ver}</div>
            </>
          )}
        </div>

        <div className="row align-items-center">
          <div className="col-lg-2 form-label-grid">
            <label htmlFor="validationInput" className="form-label">
              {t("dcs0101.form.label.ip")}
            </label>
          </div>
          <div className="col-lg-4">{model.ip}</div>
          <div className="col-lg-2 form-label-grid border-left">
            <label htmlFor="validationInput" className="col-md-4 form-label">
              {t("dcs0101.table.header.port")}
            </label>
          </div>
          <div className="col-lg-4">{model.port}</div>
        </div>

        {model.connProtTp && model.connProtTp.id === VariablesConstant.PROTOCOL_MODBUS && (
          <>
            <div className="row align-items-center">
              <div className="col-lg-2 form-label-grid">
                <label className="form-label">{t("dcs0101.form.label.slaveId")}</label>
              </div>
              <div className="col-lg-4">{model.slaveId}</div>
              <div className="col-lg-2 form-label-grid border-left">
                <label className="form-label">{t("dcs0101.form.label.offset")}</label>
              </div>
              <div className="col-lg-4">{model.dataOffset}</div>
            </div>
            <div className="row align-items-center border-left">
              <div className="col-lg-2 form-label-grid">
                <label className="form-label">{t("dcs0101.form.label.quantity")}</label>
              </div>
              <div className="col-lg-10">{model.quantity}</div>
            </div>
          </>
        )}

        {model.connProtTp && model.connProtTp.id === VariablesConstant.PROTOCOL_MQTT && (
          <>
            <div className="row align-items-center">
              <div className="col-lg-2 form-label-grid">
                <label className="form-label">{t("dcs0101.form.label.clientId")}</label>
              </div>
              <div className="col-lg-4">{model.clientId}</div>
              <div className="col-lg-2 form-label-grid border-left">
                <label className="form-label">{t("dcs0101.form.label.topic")}</label>
              </div>
              <div className="col-lg-4">{model.topic}</div>
            </div>
          </>
        )}

        {model.connProtTp && model.connProtTp.id === VariablesConstant.PROTOCOL_OPC_UA && (
          <>
            <div className="row align-items-center">
              <div className="col-lg-2 form-label-grid">
                <label className="form-label">{t("dcs0101.form.label.serverName")}</label>
              </div>
              <div className="col-lg-4">{model.serverName}</div>
              <div className="col-lg-2 form-label-grid border-left">
                <label className="col-md-4 form-label">{t("dcs0101.form.label.connectionType")}</label>
              </div>
              <div className="col-lg-4">{Constant.SOUTH_KOREA === lang ? model.connectionType.commNm : model.connectionType.commNmEn}</div>
            </div>

            {model.extraInfo && Object.keys(model.extraInfo).length > 0 && (
              <>
                <div className="row">
                  <div className="col-lg-2 form-label-grid">
                    <label className="form-label">{t("dcs0101.form.label.extraInfo")}</label>
                  </div>
                  <div className="col-lg-10">
                    <div className="demo-checkbox d-flex flex-column">
                      <div className="mb-2">
                        <span>Security Modes: </span>
                        {model.extraInfo?.secModes ? (Constant.SOUTH_KOREA === lang ? model.extraInfo.secModes.commNm : model.extraInfo.secModes.commNmEn) : "-"}
                        {model.connectionType.commCd === VariablesConstant.UA_CONNECT_TP_TCP && <>{uaSecModesTcp?.find((ele: ComMap) => ele.commCd === model.extraInfo.secModes)?.commNmEn || "-"}</>}

                        {model.connectionType.commCd === VariablesConstant.UA_CONNECT_TP_HTTPS && (
                          <>{uaSecModesHttps?.find((ele: ComMap) => ele.commCd === model.extraInfo.secModes)?.commNmEn || "-"}</>
                        )}
                      </div>

                      <div className="mb-2">
                        <span>Security Policies: </span>
                        {uaSecPolicies?.find((ele: ComMap) => ele.commCd === model.extraInfo.secPolicies)?.commNmEn || "-"}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        )}
        {model.username && model.pwd && (
          <div className="row align-items-center">
            <div className="col-lg-2 form-label-grid">
              <label className="form-label">{t("dcs0101.form.label.username")}</label>
            </div>
            <div className="col-lg-4">{model.username}</div>
            <div className="col-lg-2 form-label-grid border-left">
              <label className="form-label">{t("dcs0101.form.label.pwd")}</label>
            </div>
            <div className="col-lg-4">{model.pwd}</div>
          </div>
        )}

        <div className="row align-items-center">
          <div className="col-lg-2 form-label-grid">
            <label className="form-label">{t("dcs0101.form.label.kafkaTopic")}</label>
          </div>
          <div className="col-lg-4">{model.kafkaTopic}</div>
          <div className="col-lg-2 form-label-grid border-left">
            <label className="form-label">{t("dcs0101.form.label.tableNm")}</label>
          </div>
          <div className="col-lg-4">{model.tableNm}</div>
        </div>

        {model.dataCycle && (
          <div className="row align-items-center">
            <div className="col-lg-2 form-label-grid">
              <label className="form-label">{t("dcs0101.form.label.dataCycle")}</label>
            </div>
            <div className="col-lg-10">{cronstrue.toString(model.dataCycle)}</div>

            {/* <Cron className="mt-3" value={model.dataCycle} setValue={setDataCycle} readOnly /> */}
            {/* <ReQuartzCron cssClassPrefix="dcs " value={model.dataCycle} onChange={setDataCycle} disabled /> */}
          </div>
        )}
      </div>
      {model.connProtTp && (
        <>
          <div className="col-lg-12 my-3">
            <h3 className="header-title">{t("dcs0101.title.dialog.detailConnection")}</h3>
          </div>
          <div className="tbl-st scroll-x">
            <table>
              <colgroup>
                <col style={{ width: "5%" }} />
                <col style={{ width: "auto" }} />
                <col style={{ width: "auto" }} />
                {model.connProtTp?.id === VariablesConstant.PROTOCOL_OPC_UA && <col style={{ width: "auto" }} />}
              </colgroup>
              <thead>
                <tr>
                  <th className="text-center">{t("dcs0101.table.header.no")}</th>
                  {model.connProtTp?.id === VariablesConstant.PROTOCOL_MODBUS && <th className="text-center">{t("dcs0101.form.label.offset")}</th>}
                  {model.connProtTp?.id === VariablesConstant.PROTOCOL_MQTT && <th className="text-center">{t("dcs0101.form.label.field")}</th>}
                  {model.connProtTp?.id === VariablesConstant.PROTOCOL_OPC_UA && (
                    <>
                      <th className="text-center">{t("dcs0101.form.label.nsIdx")}</th>
                      <th className="text-center">{t("dcs0101.form.label.identifier")}</th>
                    </>
                  )}
                  <th className="text-center">{t("dcs0101.form.label.colNm")}</th>
                </tr>
              </thead>
              <tbody>
                {dataMap?.map((data: any, index: number) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    {model.connProtTp?.id === VariablesConstant.PROTOCOL_MODBUS && <td className="text-center">{data.offSet}</td>}
                    {model.connProtTp?.id === VariablesConstant.PROTOCOL_MQTT && <td className="text-center">{data.field || "-"}</td>}
                    {model.connProtTp?.id === VariablesConstant.PROTOCOL_OPC_UA && (
                      <>
                        <td className="text-center">{data.nsIndex}</td>
                        <td className="text-center">{data.identifier}</td>
                      </>
                    )}
                    <td className="text-center">{data.columnName || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}
